import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ritesh Nagrikar </span>
            from <span className="purple"> Nagpur, India.</span>
            <br />
            "I'm currently exploring opportunities in the field of web development.".
            <br />
            I have completed Engineering in IT at PBCOE
            Nagpur.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
          
            <li className="about-activity">
              <ImPointRight /> Playing Guitar
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
